import { collection, doc, getDoc, setDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';

const LIMITS = {
  SUBMISSIONS_PER_24H: 5,
  DRAFT_SAVES_PER_MINUTE: 15,
};

const RATE_DOC = 'research_rate_limits';

export async function assertCanSubmitApplication(userId) {
  const since = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
  const q = query(
    collection(db, 'research_submissions'),
    where('userId', '==', userId),
    where('submittedAt', '>=', since)
  );
  const snap = await getDocs(q);
  if (snap.size >= LIMITS.SUBMISSIONS_PER_24H) {
    throw new Error(
      `You can submit up to ${LIMITS.SUBMISSIONS_PER_24H} applications per day. Please try again tomorrow or contact support.`
    );
  }
}

export async function assertCanSaveDraft(userId) {
  const ref = doc(db, RATE_DOC, userId);
  const snap = await getDoc(ref);
  const now = Date.now();
  const windowMs = 60 * 1000;
  let saves = snap.exists() ? snap.data().draftSaveTimestamps || [] : [];
  saves = saves.filter((t) => now - t < windowMs);

  if (saves.length >= LIMITS.DRAFT_SAVES_PER_MINUTE) {
    throw new Error('Too many draft saves. Please wait a moment before continuing.');
  }

  saves.push(now);
  await setDoc(ref, { draftSaveTimestamps: saves, updatedAt: now }, { merge: true });
}
